import {
  SERVICES_AN_ERROR_OCCURRED_CHECKING,
  SERVICES_AN_ERROR_OCCURRED_LOADING,
} from 'common/constants/services/services';

// Check Measurement Date
export const CHECK_MEASUREMENT_DATE_BY_CAP_TABLE_QUERY_KEY = 'CHECK_MEASUREMENT_DATE_BY_CAP_TABLE';
export const CHECK_MEASUREMENT_DATE_BY_CAP_TABLE_TITLE = 'Measurement Date';
export const CHECK_MEASUREMENT_DATE_BY_CAP_TABLE_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_CHECKING(
  CHECK_MEASUREMENT_DATE_BY_CAP_TABLE_TITLE
);

// Primary Cap Table
export const PRIMARY_CAP_TABLE_BY_CMD_QUERY_KEY = 'PRIMARY_CAP_TABLE_BY_CMD';
export const PRIMARY_CAP_TABLE_BY_CMD_TITLE = 'Primary Cap Table';
export const PRIMARY_CAP_TABLE_BY_CMD_DEFAULT_ERROR_MESSAGE
  = SERVICES_AN_ERROR_OCCURRED_CHECKING(PRIMARY_CAP_TABLE_BY_CMD_TITLE);

// Cap Table by id
export const CAP_TABLE_BY_ID_QUERY_KEY = 'CAP_TABLE_BY_ID';
export const CAP_TABLE_BY_ID_TITLE = 'Cap Table';
export const CAP_TABLE_BY_ID_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(CAP_TABLE_BY_ID_TITLE);
